import React from "react";

const cards = [
  {
    title: "No payroll changes,\nno heavy lifting",
    description:
      "DailyPay’s platform is a time saver for your HR and Benefits teams with zero disruption to your existing systems or processes.",
  },
  {
    title: "Connect in minutes:\n180+ integrations & growing",
    description:
      "Leverage our pre-built integrations with leading Human Capital Management (HCM), payroll, and time-management systems for an easy implementation.",
  },
  {
    title: "Best-in-class\nimplementation support",
    description:
      "From day one to launch and beyond, our dedicated team works with you to ensure a smooth, successful rollout.",
  },
];

const IntegrationCards = () => {
  return (
    <section className="w-full bg-[white] py-16 lg:py-12">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        
        {/* CARDS */}
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 lg:gap-8">
          {cards.map((card, index) => (
           <div
  key={index}
  className="bg-[#eee2d7] rounded-[10px] px-7 sm:px-9 py-7 sm:py-8 min-h-[260px] lg:min-h-[260px] lg:w-[400px]"
>
              
              {/* ORANGE LINE */}
              <div className="w-[78px] h-[6px] bg-[#ff5a00] mb-8 lg:mb-4"></div>

              {/* TITLE */}
            <h2 className="text-[28px] sm:text-[30px] lg:text-[24px] leading-[1.08] text-[#1d0600] font-serif font-light whitespace-pre-line lg:mb-6">
  {card.title}
</h2>

              {/* DESCRIPTION */}
              <p className="text-[18px] lg:text-[15px]  lg:font-light leading-[1.7] lg:leading-[1.4]  text-[#242222]">
                {card.description}
              </p>
            </div>
          ))}
        </div>

        {/* BOTTOM TEXT */}
        <div className="text-center mt-14">
          <p className="text-[18px] lg:text-[16px] sm:text-[20px] text-black font-light">
            See{" "}
            <span className="font-semibold underline cursor-pointer">
              what our clients say
            </span>{" "}
            about their implementation process.
          </p>
        </div>
      </div>
    </section>
  );
};

export default IntegrationCards;